import moment from 'moment'

const now = new Date()

export const yesterday = [
  moment(now).subtract(1, 'days').format('YYYY-MM-DD 00:00:00'),
  moment(now).subtract(1, 'days').format('YYYY-MM-DD 23:59:59'),
]

export const today = [
  moment(now).format('YYYY-MM-DD 00:00:00'),
  moment(now).format('YYYY-MM-DD HH:mm:ss'),
]

export const thisWeek = moment(now).isoWeekday() === 7
  ? [
    moment(now).isoWeekday(1).format('YYYY-MM-DD 00:00:00'),
    moment(now).format('YYYY-MM-DD HH:mm:ss'),
  ]
  : [
    moment(now).isoWeekday(1).format('YYYY-MM-DD 00:00:00'),
    moment(now).format('YYYY-MM-DD HH:mm:ss'),
  ]

export const thisMonth = [
  moment(now).startOf('month').format('YYYY-MM-DD 00:00:00'),
  moment(now).format('YYYY-MM-DD HH:mm:ss'),
]

export const thisWeekT_1 = moment(now).isoWeekday() === 1
  ? [
    moment(now).subtract(1, 'weeks').isoWeekday(1).format('YYYY-MM-DD 00:00:00'),
    moment(now).subtract(1, 'weeks').isoWeekday(7).format('YYYY-MM-DD 23:59:59'),
  ]
  : [
    moment(now).isoWeekday(1).format('YYYY-MM-DD 00:00:00'),
    moment(now).subtract(1, 'days').format('YYYY-MM-DD 23:59:59'),
  ]

export const thisMonthT_1 = moment(now).date() === 1
  ? [
    moment(now).subtract(1, 'months').startOf('month').format('YYYY-MM-DD 00:00:00'),
    moment(now).subtract(1, 'months').endOf('month').format('YYYY-MM-DD 23:59:59'),
  ]
  : [
    moment(now).startOf('month').format('YYYY-MM-DD 00:00:00'),
    moment(now).subtract(1, 'days').format('YYYY-MM-DD 23:59:59'),
  ]
